module.exports = __webpack_public_path__ + "img/infography-sm.e72ea4bc.webp";